import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { mergeRefs } from '@costar-ui/utils';
import React__default, { forwardRef, useRef, useMemo } from 'react';
import { composeRenderProps, TextArea as TextArea$2 } from 'react-aria-components';
import { useComponentTheme } from '../../../theme/theme.context.esm.js';

var _excluded = ["className", "testId", "resize"];
var TextArea = /*#__PURE__*/forwardRef(function TextArea(props, ref) {
  var theme = useComponentTheme('TextArea');
  var _props$className = props.className,
    _className = _props$className === void 0 ? '' : _props$className,
    testId = props.testId,
    _props$resize = props.resize,
    resize = _props$resize === void 0 ? 'none' : _props$resize,
    rest = _objectWithoutProperties(props, _excluded);
  var localRef = useRef(null);
  var classes = useMemo(function () {
    return composeRenderProps(_className, function (className, renderProps) {
      var classes = theme(_objectSpread2(_objectSpread2({
        readOnly: props === null || props === void 0 ? void 0 : props.readOnly
      }, renderProps), {}, {
        resize: resize,
        className: className
      }));
      return "csg-tw-text-area ".concat(classes);
    });
  }, [_className, props === null || props === void 0 ? void 0 : props.readOnly, resize, theme]);
  return /*#__PURE__*/React__default.createElement(TextArea$2
  // @ts-ignore
  , _extends({
    ref: mergeRefs(ref, localRef),
    className: classes,
    "data-testid": testId
  }, rest));
});
TextArea.displayName = 'TextArea';
var TextArea$1 = TextArea;

export { TextArea$1 as default };
//# sourceMappingURL=text-area.esm.js.map
